import { I18n } from 'i18n-js';

import hr from '../../assets/i18n/hr.json';

const i18nInit = new I18n(hr);

i18nInit.defaultLocale = 'hr';
i18nInit.locale = 'hr';
i18nInit.translations = { hr };

export const i18n = i18nInit;

export const setLang = (l: string | null) => {
  if (l === null) return;
  i18n.locale = l;
  localStorage.setItem('APP_LANG', l);
};

const savedLang = localStorage.getItem('APP_LANG');
if (savedLang !== 'hr') localStorage.setItem('APP_LANG', 'hr');
i18nInit.locale = 'hr';

export default i18n;
